<template>
  <v-dialog v-model="collectionDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form>
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
              <span class="px-3">{{ $t('Product Collections') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 pt-3 class="title no-select pb-1">
              <v-layout>{{ `${product_name} ${$t('Collections')}` }}</v-layout>
            </v-flex>

            <v-flex xs12 style="margin-top: 20px">
              <v-layout row wrap class="form-table-header">
                <v-flex xs1 class="pa-2 form-table-content">#</v-flex>
                <v-flex xs5 class="pa-2 form-table-content">{{ $t('Name') }}</v-flex>
                <v-flex xs2 class="pa-2 form-table-content">{{ $t('Quantity') }}</v-flex>
                <v-flex xs2 class="pa-2 form-table-content">{{ `${$t('Price')} (${systemCurrency})` }}</v-flex>
                <v-flex xs2 class="form-table-content">
                  <v-tooltip top>
                    <v-btn label @click="addRow()" small slot="activator" icon color="green">
                      <v-icon color="white">add</v-icon>
                    </v-btn>
                    <span>{{ $t('Add new row') }}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>

              <template v-if="rowNumbers > 0">
                <v-layout row wrap v-for="(row, index) in rowNumbers" :key="index">
                  <v-flex xs1 pa-1 style="text-align: center; margin-top: 20px; font-size: 16px">{{
                    index + 1
                  }}</v-flex>

                  <v-flex xs5 class="pa-1">
                    <v-text-field
                      v-model="name[index]"
                      :label="`${$t('Name')} *`"
                      hide-details
                      box
                      :data-vv-name="'Collection Name' + (index + 1)"
                      background-color="white"
                      :error="errors.has('Collection Name' + (index + 1))"
                      v-validate="'required'"
                    />
                  </v-flex>

                  <v-flex xs2 class="pa-1">
                    <v-text-field
                      v-model="quantity[index]"
                      :label="`${$t('Quantity')} *`"
                      hide-details
                      box
                      :data-vv-name="'Collection Quantity' + (index + 1)"
                      background-color="white"
                      :error="errors.has('Collection Quantity' + (index + 1))"
                      v-validate="'required|decimal:3|min_value:0'"
                    />
                  </v-flex>

                  <v-flex xs2 class="pa-1">
                    <v-text-field
                      v-model="price[index]"
                      :label="`${$t('Price')} *`"
                      hide-details
                      box
                      :data-vv-name="'Collection Price' + (index + 1)"
                      background-color="white"
                      :error="errors.has('Collection Price' + (index + 1))"
                      v-validate="'required|decimal:3|min_value:0'"
                    />
                  </v-flex>

                  <v-flex xs1 pt-3 style="text-align: center">
                    <v-tooltip v-if="status[index] === 'save'" top>
                      <v-btn
                        style="margin: 0px !important"
                        label
                        flat
                        @click="saveRow(index)"
                        small
                        slot="activator"
                        icon
                        color="success"
                        :loading="btnUpdateLoading[index]"
                      >
                        <v-icon>save</v-icon>
                      </v-btn>
                      <span>{{ $t('Save') }}</span>
                    </v-tooltip>

                    <v-tooltip v-else-if="status[index] === 'update'" top>
                      <v-btn
                        style="margin: 0px !important"
                        label
                        flat
                        @click="updateRow(index)"
                        small
                        slot="activator"
                        icon
                        color="primary"
                        :loading="btnUpdateLoading[index]"
                      >
                        <v-icon>save</v-icon>
                      </v-btn>
                      <span>{{ $t('Update') }}</span>
                    </v-tooltip>
                  </v-flex>

                  <v-flex xs1 pt-3 style="text-align: center">
                    <v-tooltip top v-if="status[index] === 'save'">
                      <v-btn
                        style="margin: 0px !important"
                        label
                        flat
                        @click="removeRow(index)"
                        small
                        slot="activator"
                        icon
                        color="error"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <span>{{ $t('Delete this record') }}</span>
                    </v-tooltip>

                    <v-tooltip top v-else-if="status[index] === 'update'">
                      <v-btn
                        style="margin: 0px !important"
                        label
                        flat
                        @click="showConfirmDeletion(index)"
                        small
                        slot="activator"
                        icon
                        color="error"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <span>{{ $t('Delete this record') }}</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </template>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>

      <confirm-deletion
        :deleteDialog="deleteDialog"
        :btnDeleteLoading="btnDeleteLoading"
        @hidemodal="deleteDialog = false"
        @confirm="deleteRow()"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'view-component',

  props: {
    collectionDialog: { type: Boolean, required: true },
    rawMaterial: { type: Boolean, required: false, default: false }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: [false],
      deleteDialog: false,
      btnDeleteLoading: false,
      deleteIndex: 0,
      rowNumbers: 0,
      product_name: '',
      product_id: '',
      collections: [],
      id: [],
      name: [],
      price: [],
      quantity: [],
      status: []
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      productInfo: 'products/getProductInfo',
      rawMaterialInfo: 'rawMaterials/getRawMaterialInfo',
      fullProductTypesList: 'productTypes/getFullProductTypesList'
    })
  },

  watch: {
    collectionDialog: {
      immediate: false,
      handler() {
        if (this.collectionDialog) {
          this.addEscKeyListener()

          const viewInfo = this.rawMaterial ? this.rawMaterialInfo : this.productInfo
          this.collections = viewInfo.collections
          this.product_id = viewInfo.product_id
          this.product_name = viewInfo.product_name
          this.rowNumbers = 0
          this.id = []
          this.name = []
          this.price = []
          this.quantity = []
          this.status = []
          this.btnUpdateLoading = []
          if (this.collections.length > 0) {
            this.rowNumbers = this.collections.length
            this.collections.forEach(data => {
              this.id.push(data.collection_id)
              this.name.push(data.collection_name)
              this.price.push(data.collection_price)
              this.quantity.push(data.collection_quantity)
              this.status.push('update')
              this.btnUpdateLoading.push(false)
            })
          }
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addCollection: 'collections/addCollection',
      updateCollection: 'collections/updateCollection',
      deleteCollection: 'collections/deleteCollection',
      fetchProductInfo: 'products/fetchProductInfo',
      fetchRawMaterialInfo: 'rawMaterials/fetchRawMaterialInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.collectionDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    addRow() {
      this.status.push('save')
      this.btnUpdateLoading.push(false)
      this.rowNumbers = this.rowNumbers + 1
    },

    removeRow(index) {
      this.rowNumbers = this.rowNumbers - 1
      this.status.splice(index, 1)
      this.btnUpdateLoading.splice(index, 1)
      this.name.splice(index, 1)
      this.price.splice(index, 1)
      this.quantity.splice(index, 1)
    },

    saveRow(index) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading[index] = true
          let formData = new FormData()
          formData.append('collection_product_id_fk', this.product_id)
          formData.append('collection_name', this.name[index])
          formData.append('collection_price', this.price[index])
          formData.append('collection_quantity', this.quantity[index])

          this.addCollection(formData)
            .then(() => {
              this.status[index] = 'update'
              this.btnUpdateLoading[index] = false
              this.addRow()
              this.rawMaterial ? this.fetchRawMaterialInfo(this.product_id) : this.fetchProductInfo(this.product_id)
            })
            .catch(() => {
              this.btnUpdateLoading[index] = false
            })
        }
      })
    },

    updateRow(index) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading[index] = true
          let formData = new FormData()
          formData.append('collection_product_id_fk', this.product_id)
          formData.append('collection_name', this.name[index])
          formData.append('collection_price', this.price[index])
          formData.append('collection_quantity', this.quantity[index])
          formData.append('_method', 'patch')

          let payload = { id: this.collections[index].collection_id, formData }

          this.updateCollection(payload)
            .then(() => {
              this.btnUpdateLoading[index] = false
            })
            .catch(() => {
              this.btnUpdateLoading[index] = false
            })
        }
      })
    },

    showConfirmDeletion(index) {
      this.deleteIndex = index
      this.deleteDialog = true
    },

    deleteRow() {
      this.deleteCollection(this.collections[this.deleteIndex].collection_id).then(() => {
        this.removeRow(this.deleteIndex)
        this.btnDeleteLoading = false
        this.deleteDialog = false
      })
    }
  }
}
</script>

<style scoped />
